import { companyFilterChange } from 'containers/PartnerOptions/actions'

import {
  CREATE_ATO_INCIDENT_ASYNC,
  FETCH_DATA_ASYNC,
  FETCH_DEPARTMENTS_ASYNC,
  LICENSE_DATA_REQUEST_ASYNC,
  RESET_ALL_FILTERS,
  RESET_SELECTED_ADDONS,
  SET_ALERT_ID,
  SET_ARRIVAL_DATE,
  SET_DEPARTMENT,
  SET_EMAIL_ADDRESS,
  SET_PAGE_NUMBER,
  TOGGLE_ADDON_TO_UNLOCK,
} from './constants'

const fetchAccountInvestigationData = () => ({ type: FETCH_DATA_ASYNC.INITIATE })
export const fetchAccountInvestigationDataSuccess = (data) => ({
  type: FETCH_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAccountInvestigationDataError = (error) => ({
  type: FETCH_DATA_ASYNC.ERROR,
  payload: error,
})
const fetchAccountInvestigationDataCancel = (reason) => ({
  type: FETCH_DATA_ASYNC.CANCEL,
  reason,
})

const fetchDepartments = () => ({ type: FETCH_DEPARTMENTS_ASYNC.INITIATE })
export const fetchDepartmentsSuccess = (data) => ({
  type: FETCH_DEPARTMENTS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDepartmentsError = (error) => ({
  type: FETCH_DEPARTMENTS_ASYNC.ERROR,
  payload: error,
})
const fetchDepartmentsCancel = (reason) => ({
  type: FETCH_DEPARTMENTS_ASYNC.CANCEL,
  reason,
})

const setPageNumber = (page) => ({
  type: SET_PAGE_NUMBER,
  payload: { page },
})
const setArrivalDate = (arrivalDate) => ({
  type: SET_ARRIVAL_DATE,
  payload: { arrivalDate },
})
const setSelectedDepartment = (department) => ({
  type: SET_DEPARTMENT,
  payload: { department },
})
const setEmailAddress = (emailAddress) => ({
  type: SET_EMAIL_ADDRESS,
  payload: { emailAddress },
})
const resetAllFilters = () => ({ type: RESET_ALL_FILTERS })

const getLicenseInformation = () => ({
  type: LICENSE_DATA_REQUEST_ASYNC.INITIATE,
})
export const getLicenseInformationSuccess = (data) => ({
  type: LICENSE_DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getLicenseInformationError = (error) => ({
  type: LICENSE_DATA_REQUEST_ASYNC.ERROR,
  payload: error,
})
const getLicenseInformationCancel = () => ({
  type: LICENSE_DATA_REQUEST_ASYNC.CANCEL,
})

const toggleAddonToUnlock = (addon) => ({
  type: TOGGLE_ADDON_TO_UNLOCK,
  payload: { addon },
})

const resetSelectedAddons = () => ({
  type: RESET_SELECTED_ADDONS,
})

const createAtoIncident = () => ({ type: CREATE_ATO_INCIDENT_ASYNC.INITIATE })
export const createAtoIncidentSuccess = (data) => ({
  type: CREATE_ATO_INCIDENT_ASYNC.SUCCESS,
  payload: { data },
})
export const createAtoIncidentError = (error) => ({
  type: CREATE_ATO_INCIDENT_ASYNC.ERROR,
  payload: error,
})
const createAtoIncidentCancel = (reason) => ({
  type: CREATE_ATO_INCIDENT_ASYNC.CANCEL,
  reason,
})

const setAlertId = (alertId) => ({
  type: SET_ALERT_ID,
  payload: { alertId },
})

export default {
  companyFilterChange,
  fetchAccountInvestigationData,
  fetchAccountInvestigationDataSuccess,
  fetchAccountInvestigationDataError,
  fetchAccountInvestigationDataCancel,
  fetchDepartments,
  fetchDepartmentsSuccess,
  fetchDepartmentsError,
  fetchDepartmentsCancel,
  setPageNumber,
  setArrivalDate,
  setSelectedDepartment,
  setEmailAddress,
  resetAllFilters,
  getLicenseInformation,
  getLicenseInformationCancel,
  toggleAddonToUnlock,
  resetSelectedAddons,
  createAtoIncident,
  createAtoIncidentCancel,
  setAlertId,
}
